// 明道云客服/员工选择弹窗（复用 account-settings「绑定CRM账号」的选人弹窗逻辑，抽成可复用组件）
// 接口：GET {BASE}/mingdaoyun/users?pageIndex=&pageSize=&userStatus=1 → { code, data:{ users:[{accountId,fullname}], count } }
import React, { useEffect, useState } from 'react';
import { Dialog, Table, Button, Space, Pagination, MessagePlugin } from 'tdesign-react';
import { API_CONFIG } from '../../config/api';

const BASE = (API_CONFIG && API_CONFIG.BASE_URL) || '/api';
const PAGE_SIZE = 20;

/**
 * 选择客服/员工弹窗
 * props:
 *  - visible: 是否展示
 *  - title: 标题（默认「选择客服」）
 *  - initial: { accountId, fullname } 当前已选（用于高亮）
 *  - onCancel(): 关闭
 *  - onSelect(emp): 确认选择（emp={accountId, fullname}）
 */
export default function EmployeePicker({ visible, title = '选择客服', initial, onCancel, onSelect }) {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [sel, setSel] = useState(null);

  // 打开时加载第一页并回显已选
  useEffect(() => {
    if (visible) {
      setPage(1);
      setSel(initial && initial.accountId ? initial : null);
      load(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  const load = async (pageIndex) => {
    setLoading(true);
    try {
      const resp = await fetch(`${BASE}/mingdaoyun/users?pageIndex=${pageIndex}&pageSize=${PAGE_SIZE}&userStatus=1`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` },
      });
      const data = await resp.json();
      if (data && data.code === 200) {
        setRows((data.data && data.data.users) || []);
        setTotal((data.data && data.data.count) || 0);
        setPage(pageIndex);
      } else {
        MessagePlugin.error((data && data.message) || '获取员工列表失败');
      }
    } catch (e) {
      MessagePlugin.error('获取员工列表失败');
    } finally {
      setLoading(false);
    }
  };

  // TDesign Table 单选列（type='single'），选中态由组件自绘，无自定义控件
  const columns = [
    { colKey: 'row-select', type: 'single', width: 40 },
    { colKey: 'fullname', title: '姓名', ellipsis: true, cell: ({ row }) => row.fullname || '-' },
    { colKey: 'accountId', title: '登录账号', ellipsis: true, cell: ({ row }) => row.accountId || '-' },
  ];

  // 单选：从选中 key（accountId）反查整行对象，回填给父组件
  const onSelectChange = (keys) => {
    const k = keys && keys.length ? String(keys[0]) : '';
    setSel(k ? rows.find((r) => String(r.accountId) === k) || null : null);
  };

  const confirm = () => {
    if (!sel) { MessagePlugin.warning('请选择一位员工'); return; }
    onSelect({ accountId: sel.accountId, fullname: sel.fullname });
  };

  return (
    <Dialog header={title} visible={!!visible} width="720px" closeOnOverlayClick onClose={onCancel}
      footer={
        <div style={{ textAlign: 'right' }}>
          <Space>
            <Button theme="default" variant="text" size="small" onClick={onCancel}>取消</Button>
            <Button theme="primary" variant="text" size="small" onClick={confirm}>确定</Button>
          </Space>
        </div>
      }>
      <p style={{ margin: '0 0 12px', color: '#888', fontSize: 12 }}>选择一位员工作为该兼职人员的负责客服</p>
      <Table
        rowKey="accountId"
        resizable
        data={rows}
        loading={loading}
        hover
        size="small"
        columns={columns}
        empty={<span>暂无员工</span>}
        selectOnRowClick
        selectedRowKeys={sel ? [String(sel.accountId)] : []}
        onSelectChange={onSelectChange}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 12 }}>
        <Pagination
          total={total}
          pageSize={PAGE_SIZE}
          current={page}
          showJumper
          onChange={(info) => load(typeof info === 'number' ? info : info.current)}
        />
      </div>
    </Dialog>
  );
}
